import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import constants from '../../../constants';

import { connect } from 'react-redux';
import { selectAuthenticated } from '../../../redux/auth/selectors';

import ContactUs from '../components/ContactUs';

import artSafety from '../assets/art-safety.png';

import containerStyles from './ExpiredInvitation.scss';
import qmStyles from '../../../theme/qmStyles';
import Button from '../../../components/Button';

const ExpiredInvitation = ({ authenticated }) => (
  <div className={containerStyles.container}>
    <img src={artSafety} alt="map" style={{ marginTop: qmStyles.gutter }} />
    <p>Looks like this invitation has expired!</p>
    {authenticated ? (
      <Button
        text="Continue to Quartermaster"
        onClick={() => {
          window.location = constants.WORKING_CONFIG.BASE_URL;
        }}
        style={{
          width: 360,
          marginTop: qmStyles.gutter,
          marginBottom: qmStyles.gutter,
        }}
      />
    ) : (
      <Link to="/app/signup/signin">
        <p className={containerStyles.button}>Sign In</p>
      </Link>
    )}
    <ContactUs />
  </div>
);

ExpiredInvitation.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  authenticated: selectAuthenticated(state),
});

export default connect(mapStateToProps)(ExpiredInvitation);
